// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__pZhNk","actions":"styles_actions__y4ne+"};